module.exports = __webpack_public_path__ + "officialStatic/img/circle1.56767dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/test/circle1.png
// module id = iKrq
// module chunks = 0